import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Table } from 'primeng/table';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-empresa-editar',
  templateUrl: './empresa-editar.component.html',
  styleUrls: ['./empresa-editar.component.scss']
})
export class EmpresaEditarComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;

  loading: boolean = false;
  value?: string;
  id?: number;
  empresa?: Empresa;
  messages: Message[] = [];
  messagemVisivel: boolean = false;

  eventoAbaTributacao: string = 'LISTAR';
  eventoAbaPlanoConta: string = 'LISTAR';
  eventoAbaUsuario: string = 'LISTAR';

  idUsuarioEmpresa?: number;
  idTributacao?: number;
  idPlanoContaEmpresa?: number;


  uploadedFiles: any[] = [];
  logoData?: SafeUrl;
  constructor(private empresaService: EmpresaService,
    private activatedRouter: ActivatedRoute,
    private erroService: ErroService,
    private sanitizer: DomSanitizer
  ) { }


  ngOnInit(): void {
    this.carregarIdUrl();
    this.carregarEmpresaPorId();
  }


  carregarIdUrl() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarEmpresaPorId() {
    this.empresaService.buscarPorId(this.id).subscribe({
      next: (data: Empresa) => {
        this.empresa = data;
        console.log(this.empresa.id)
        this.buscarLogo();
      },
      error: (err: any) => {
        console.log('erro buscar contrato: ', err);
      }
    });
  }

  atualizar() {
    this.empresaService.atualizar(this.empresa, this.id).subscribe({
      next: (data: Empresa) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  salvarLogo(event: any) {
    console.log(event)
    const arquivo = event.files[0];
    this.empresaService.salvarLogo(this.id!, arquivo).subscribe({
      next: () => {
        console.log('logo salva')
        this.carregarEmpresaPorId();
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  buscarLogo() {
    /*
    this.empresaService.buscarLogo(this.id!).subscribe({
      next: (data: Blob) => {
        console.log(data)
        this.criarImagem(data);
      },
      error: (err: any) => {
        console.log(err)
      }
    });*/
  }

  criarImagem(imagem: Blob) {
    const reader = new FileReader();
    reader.onload = () => {
      this.logoData = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
    };

    if (imagem) {
      reader.readAsDataURL(imagem);
    }
  }

  abaSelecionada(evento: any) {
    this.messagemVisivel = false;
    this.eventoAbaUsuario = 'LISTAR';
    this.eventoAbaPlanoConta = 'LISTAR';
    this.eventoAbaTributacao = 'LISTAR';
  }


  inserirUsuario() {
    this.eventoAbaUsuario = 'INSERIR';
  }

  inserirPlanoContaEmpresa() {
    this.eventoAbaPlanoConta = 'INSERIR';
  }

  inserirTributacao() {
    this.eventoAbaTributacao = 'INSERIR';
  }

  trocarComponenteUsuario(event: any) {
    this.idUsuarioEmpresa = event.id;
    this.eventoAbaUsuario = event.modo;
  }
  trocarComponentePlanoConta(event: any) {
    this.idPlanoContaEmpresa = event.id;
    this.eventoAbaPlanoConta = event.modo;
  }
  trocarComponenteTributacao(event: any) {
    this.idTributacao = event.id;
    this.eventoAbaTributacao = event.modo;
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

}